
const config: IConfig = {
  serve: 'https://rap.hduhelp.com/api',
  keys: ['some secret hurr'],
  session: {
    key: 'koa:sess',
  },
}

export default config
